<template>
<nav class="container">
    <div class="row">
        <div class="col">
            <b-navbar toggleable="md">
                <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
                <b-collapse is-nav id="nav_collapse">
                    <b-navbar-nav fill class="w-100">
                        <b-nav-item href="#" v-scroll-to="'#home'" class="navbar-item">{{items[0]}}</b-nav-item>
                        <b-nav-item href="#" v-scroll-to="'#translations'" class="navbar-item">{{items[1]}}</b-nav-item>
                        <b-nav-item href="#" v-scroll-to="'#portfolio'" class="navbar-item">{{items[2]}}</b-nav-item>
                        <b-nav-item href="#" v-scroll-to="'#about'" class="navbar-item">{{items[3]}}</b-nav-item>
                        <b-nav-item href="#" v-scroll-to="'#links'" class="navbar-item">{{items[4]}}</b-nav-item>
                        <b-nav-item href="#" v-scroll-to="'#contact'" class="navbar-item">{{items[5]}}</b-nav-item>
                        <b-nav-item href="#" v-scroll-to="'#impressum'" class="navbar-item">{{items[6]}}</b-nav-item>
                        <b-nav-item href="#" v-scroll-to="'#privacy'" class="navbar-item">{{items[7]}}</b-nav-item>
                    </b-navbar-nav>
                </b-collapse>
            </b-navbar>
        </div>
    </div>
</nav>
</template>

<script>
export default {
    data: () => ({}),
    props: ['items'],
}
</script>

<style scoped>
.navbar-nav .nav-link {
    font-size: 1.2em;
    color: #2c3e50;
}

.navbar-nav .nav-link:hover {
    color: #e14e26;
}
</style>
